$(document).ready(function() {

  if ($('body.tax-product_cat').length || $('body.search-results').length || $('form.cart').length) {
    $('form.cart .input-text.qty').on('click', function() {
      $(this).closest('form').find('.add_to_cart_button').html('Add to cart');
    });

    $('.add_to_cart_button').on('click', function(e) {
      e.preventDefault();

      var $thisbutton = $( this );
      var $form = $thisbutton.closest('form');
      var data = {
        "action" : "woocommerce_add_variation_to_cart"
      };

      $.each( $thisbutton.data(), function( key, value ) {
        data[key] = value;
      });

      $thisbutton.html('Adding');
      $form.addClass('loading');

      // Ajax action
      $.post( '/add-variation-to-cart', data, function( response ) {
        if ( ! response ) {
          return;
        }

        $form.removeClass('loading');
        $thisbutton.html('Item Added');

        if (response.message) {
          alert(response.message);
          return;
        }

        var fragments = response.fragments;

        $.ajax({
          url: "/get-cart-count/",
          method: "GET",
          success: function(resp) {
            // Update cart count
            if ( resp > 99) {
              resp = '99+';
            };
            $(".cart-count").html(resp);

            // Replace fragments
            if (fragments) {
              $.each( fragments, function( key, value ) {
                $( key ).replaceWith( value );
              });
            }
            if ($(window).width() > 768) {
              if ($('body.has-fixed-header').length) {
                showHideCart($('.fixed-header').find('.cart-popover'));
              } else {
                showHideCart($('.main-header').find('.cart-popover'));
              }
            }
          }
        });
      });

      return false;
    });

    $('form.cart input[name=quantity]').on('change', function() {
      var quantity = $(this).val();
      $(this).closest('form').find('.add_to_cart_button').data('quantity', quantity);
    }).trigger('change');

  }

});
